module.exports = __webpack_public_path__ + "static/media/canyon.644c3c24.svg";